<ng-container
  *ngIf="
    !isActiveFilter &&
      !string_filter &&
      (baseDatasource.isFinishLoadingSubject | async) &&
      (baseDatasource.totalItem$ | async) === 0;
    else elseBlock
  "
  cardBody
>
  <app-card-empty icon="{{ iconNone }}" text="Belum terdapat data retail."></app-card-empty>
</ng-container>

<ng-template #elseBlock>
  <!-- begin::Card -->
  <app-card [cardBodyClasses]="'pt-2'" [header]="true">
    <!--begin::Card header-->
    <ng-container cardHeader>
      <div *ngIf="headerTypeCounting" class="h3">
        Cakupan Retailer ({{ baseDatasource.totalItem$ | async }})
      </div>

      <app-input-search
        (actionFilter)="onSearch($event)"
        *ngIf="headerTypeFilter"
        [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject"
        placeholder="Cari Nama Toko / Pemilik"
        value="{{ string_filter }}"
      ></app-input-search>

      <div
        *ngIf="headerTypeFilter"
        class="ms-auto position-relative"
        data-kt-customer-table-toolbar="base"
      >
        <!--begin::Filter-->
        <app-filter-table
          (actionClick)="handleOpenFilter()"
          (actionReset)="handleResetFilter()"
          [isActiveFilter]="isActiveFilter"
          [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject"
          [isOpenFilter]="isOpenFilter"
        >
          <div
            class="menu menu-sub menu-sub-dropdown w-300px w-md-350px show filter-body"
            id="kt-toolbar-filter"
          >
            <!--begin::Header-->
            <div class="px-7 py-5">
              <div class="fs-4 text-dark fw-bold">Filter</div>
            </div>
            <div class="separator border-gray-200"></div>

            <form
              (ngSubmit)="handleSubmitFilter()"
              [formGroup]="filterForm"
              [ngClass]="'w-100'"
              class="form"
            >
              <div class="px-7 py-5">
                <div class="mb-4" *ngIf="partnershipFilter">
                  <label class="form-label mb-4">Kemitraan:</label>
                  <div class="form-check p-0">
                    <mat-radio-group
                      [formControlName]="'is_mac'"
                      class="w-100 d-flex gap-4"
                      ngDefaultControl
                    >
                      <ng-container *ngFor="let option of filterRetailerIsMac">
                        <mat-radio-button [value]="option.value" class="col">{{
                          option.display
                        }}</mat-radio-button>
                      </ng-container>
                    </mat-radio-group>
                  </div>
                </div>

                <div class="mb-4">
                  <label class="form-label mb-4">Area</label>
                  <app-input-select
                    [class]="'w-100'"
                    [options]="listRetailerAreaSubject.value"
                    formControlName="area_id"
                    ngDefaultControl
                    placeholder="Pilih area"
                    (handleChangeData)="handleChangeAreaFilter($event)"
                  />
                </div>

                <div class="mb-4">
                  <label class="form-label mb-4">Sub Area</label>
                  <app-input-select
                    [class]="'w-100'"
                    [options]="listRetailerSubAreaSubject.value"
                    formControlName="sub_area_id"
                    ngDefaultControl
                    placeholder="Pilih sub area"
                  />
                </div>

                <!--begin::Actions-->
                <div class="d-flex justify-content-end mt-6">
                  <button
                    (click)="handleResetFilter()"
                    class="btn btn-light btn-active-light-primary me-4"
                    type="reset"
                  >
                    Reset
                  </button>
                  <button
                    [disabled]="filterService.validateSubmitFilter(filterForm)"
                    class="btn btn-primary"
                    type="submit"
                  >
                    Terapkan
                  </button>
                </div>
              </div>
            </form>
          </div>
        </app-filter-table>
      </div>
    </ng-container>
    <!--end::Card header-->

    <!--begin::Card body-->
    <ng-container
      *ngIf="
        (isActiveFilter || string_filter) && (baseDatasource.totalItem$ | async) === 0;
        else elseFilterBlock
      "
      cardBody
    >
      <app-card-empty icon="{{ iconNone }}" text="Belum terdapat data retail."></app-card-empty>
    </ng-container>

    <ng-template #elseFilterBlock>
      <ng-container cardBody>
        <div class="table-responsive">
          <table
            (matSortChange)="sortTable($event)"
            [dataSource]="baseDatasource"
            class="table w-100 gy-5 table-row-bordered align-middle"
            mat-table
            matSort
          >
            <ng-container *ngFor="let tableColumn of tableColumns" [matColumnDef]="tableColumn.key">
              <!-- COLUMN HEADER -->
              <ng-container *ngIf="tableColumn.isSortable; else notSortable">
                <th
                  *matHeaderCellDef
                  [arrowPosition]="'after'"
                  [mat-sort-header]="tableColumn.key"
                  class="min-w-125px px-3"
                  mat-header-cell
                >
                  <app-table-content
                    [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject"
                    [width]="70"
                  >
                    {{ tableColumn.title }}
                  </app-table-content>
                </th>
              </ng-container>

              <ng-template #notSortable>
                <th
                  *matHeaderCellDef
                  [ngClass]="{
                    'min-w-70px text-center':
                      tableColumn.key === 'actions' || tableColumn.key === 'is_mac',
                    'w-250px': tableColumn.key === 'alamat',
                    'mw-150px':
                      tableColumn.key === 'area_manager_name' || tableColumn.key === 'createdDate',
                  }"
                  class="min-w-125px px-3"
                  mat-header-cell
                >
                  <app-table-content
                    [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject"
                    [width]="70"
                  >
                    {{ tableColumn.title }}
                  </app-table-content>
                </th>
              </ng-template>

              <!-- COLUMN DATA -->
              <td *matCellDef="let element" class="px-3" mat-cell>
                <ng-container [ngSwitch]="tableColumn.key">
                  <div *ngSwitchCase="'name'">
                    <app-table-content
                      [count]="1"
                      [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject"
                      [type]="'text'"
                    >
                      <span>{{ element[tableColumn.key] }}</span>
                      <span class="d-block">{{ element['phone_number'] }}</span>
                    </app-table-content>
                  </div>

                  <div *ngSwitchCase="'createdDate'">
                    <app-table-content
                      [count]="2"
                      [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject"
                      [type]="'text'"
                    >
                      <div>
                        {{ utilities.timeStampToDate(element['created_date'], 'dd-MM-yyyy') }}
                      </div>
                      <div>
                        {{ utilities.timeStampToDate(element['created_date'], 'HH:mm:ss') }}
                      </div>
                    </app-table-content>
                  </div>

                  <div *ngSwitchCase="'status'">
                    <app-table-content
                      [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject"
                      [type]="'text'"
                    >
                      <span
                        class="badge badge__status {{ 'badge__status--' + element['status_enum'] }}"
                      >
                        {{ element[tableColumn.key] }}
                      </span>
                    </app-table-content>
                  </div>

                  <div *ngSwitchCase="'is_mac'" class="text-center">
                    <app-table-content
                      [height]="30"
                      [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject"
                      [width]="120"
                    >
                      <img
                        *ngIf="element['is_mac']; else notMAC"
                        [src]="STRING_CONSTANTS.ICON.IC_BADGE_MAC"
                        alt="mitra"
                        class="svg-icon"
                      />
                      <ng-template #notMAC>-</ng-template>
                    </app-table-content>
                  </div>

                  <div *ngSwitchCase="'actions'" class="text-center">
                    <app-table-content
                      [count]="1"
                      [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject"
                      [type]="'icon'"
                    >
                      <span
                        (click)="handleActionDetail(element['id'])"
                        [inlineSVG]="'./assets/media/icons/ic_task.svg'"
                        class="svg-icon svg-icon-2 cursor-pointer"
                      ></span>
                    </app-table-content>
                  </div>

                  <div *ngSwitchDefault>
                    <app-table-content
                      [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject"
                    >
                      <span>{{ element[tableColumn.key] }} </span>
                    </app-table-content>
                  </div>
                </ng-container>
              </td>
            </ng-container>

            <tr
              *matHeaderRowDef="displayedColumns"
              class="fw-bold text-start text-uppercase"
              mat-header-row
            ></tr>
            <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
          </table>
        </div>

        <div class="d-flex justify-content-between py-4">
          <app-mai-material-bottom-table
            (changePage)="changePageEvent($event)"
            [baseDataTableComponent]="baseDatasource"
            [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject"
            class="w-100"
          ></app-mai-material-bottom-table>
        </div>
      </ng-container>
    </ng-template>
    <!--end::Card body-->
  </app-card>
  <!-- end::Card -->
</ng-template>
